import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const AndroidBox = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <g clipPath="url(#a)">
        <path d="M2.333 5h11.333a1.669 1.669 0 0 1 1.666 1.667V14a1.669 1.669 0 0 1-1.666 1.666H2.333A1.669 1.669 0 0 1 .666 14V6.667A1.669 1.669 0 0 1 2.333 5Zm11.333 10a1 1 0 0 0 1-1V6.667a1 1 0 0 0-1-1H2.333a1 1 0 0 0-1 1V14a1 1 0 0 0 1 1h11.333Z" />
        <path d="M7 8.334c.062 0 .123.018.176.05l2.667 1.667a.334.334 0 0 1 0 .567l-2.667 1.666a.334.334 0 0 1-.51-.284V8.668a.333.333 0 0 1 .333-.333Zm2.037 2L7.333 9.267V11.4l1.704-1.066ZM13 3.667H3A.333.333 0 0 1 3 3h10a.333.333 0 1 1 0 .667ZM11.666 1.667H4.333a.333.333 0 1 1 0-.667h7.333a.333.333 0 1 1 0 .667Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M0 .334h16v15.999H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

AndroidBox.category = 'product-category';

AndroidBox.displayName = 'AndroidBox';
